import styles from './NotificationDetailsView.module.scss';
import Box from '@components/Box';
import parse from 'html-react-parser';
import { Column, Grid, Row } from '@components/Grid';
import { getNotificationDetails, INotificationItem, markAsRead } from '@api/apiClient/notifications';
import { Loader } from '@components/Loader';
import { NotificationDetailsViewProps } from '../../types';
import { Text, TextColor } from '@components/Text';
import { useMutation, useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';

const NotificationDetailsView: React.FC<NotificationDetailsViewProps> = ({
  handlerUpdateItem,
  id,
  isListEmpty,
  refetchGetNotificationsUnreadCount
}): React.ReactElement => {
  const { t } = useTranslation();

  const { mutate: mutateMarkAsRead } = useMutation({
    mutationFn: markAsRead,
    onSuccess: () => refetchGetNotificationsUnreadCount()
  });

  const {
    data,
    isLoading,
  } = useQuery({
    queryKey: ["notificationsDetails", id],
    queryFn: () => getNotificationDetails(id ?? ""),
    enabled: Boolean(id),
    onSuccess: (result: INotificationItem) => {
      const { id, isRead } = result;
      !isRead && mutateMarkAsRead(id);
      handlerUpdateItem({ ...result, isRead: true });
    }
  });

  if (isLoading) {
    return (
      <Grid>
        <Row>
          <Column phone={12}>
            <Box pt={8}>
              <Loader
                alignment="center"
                size="s"
              />
            </Box>
          </Column>
        </Row>
      </Grid>
    );
  }

  if (!id && !isListEmpty) {
    return (
      <Grid>
        <Row>
          <Column phone={12}>
            <Box pt={8} textAlign="center">
              <Text color={TextColor.DARK_MUTED}>
                {t("notificationsPage.notSelected")}
              </Text>
            </Box>
          </Column>
        </Row>
      </Grid>
    )
  }

  if (!id && isListEmpty) {
    return (<></>);
  }

  return (
    <div className={styles.detailView}>
      {data?.content ? parse(data?.content) : null}
    </div>
  );
};

export default NotificationDetailsView;